import React, { useState } from 'react';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { useDepartment } from '../../App';
import { Send, CheckCircle, AlertCircle, Calendar } from 'lucide-react';
import './VacationFormPage.css';

const VacationFormPage = () => {
    const { selectedDepartment, departments } = useDepartment();
    const [formData, setFormData] = useState({
        full_name: '',
        start_date: '',
        end_date: ''
    });
    const [success, setSuccess] = useState(false);

    const mutation = useMutation(
        async (data) => {
            const response = await axios.post(`${API_BASE_URL}/vacations`, {
                ...data,
                department_name: selectedDepartment || null
            });
            return response.data;
        },
        {
            onSuccess: () => {
                setSuccess(true);
                setFormData({ full_name: '', start_date: '', end_date: '' });
                setTimeout(() => setSuccess(false), 5000);
            }
        }
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        setSuccess(false);
        mutation.mutate(formData);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const today = new Date().toISOString().split('T')[0];

    return (
        <div className="vacation-form-page">
            <div className="form-container">
                <div className="form-header">
                    <div className="form-icon">
                        <Calendar size={40} />
                    </div>
                    <h1>Заявка на отпуск</h1>
                    <p>Заполните форму для подачи заявки на отпуск</p>
                    {selectedDepartment && (
                        <div className="selected-department">
                            Отделение: <strong>{selectedDepartment}</strong>
                        </div>
                    )}
                </div>

                {success && (
                    <div className="alert alert-success">
                        <CheckCircle size={20} />
                        <span>Заявка успешно отправлена!</span>
                    </div>
                )}

                {mutation.isError && (
                    <div className="alert alert-error">
                        <AlertCircle size={20} />
                        <span>{mutation.error?.response?.data?.error || 'Произошла ошибка'}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="vacation-form">
                    <div className="form-group">
                        <label htmlFor="full_name">ФИО</label>
                        <input
                            type="text"
                            id="full_name"
                            name="full_name"
                            value={formData.full_name}
                            onChange={handleChange}
                            placeholder="Введите ваше ФИО"
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="start_date">Дата начала</label>
                            <input
                                type="date"
                                id="start_date"
                                name="start_date"
                                value={formData.start_date}
                                onChange={handleChange}
                                min={today}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="end_date">Дата окончания</label>
                            <input
                                type="date"
                                id="end_date"
                                name="end_date"
                                value={formData.end_date}
                                onChange={handleChange}
                                min={formData.start_date || today}
                                required
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-submit"
                        disabled={mutation.isLoading}
                    >
                        {mutation.isLoading ? (
                            <>
                                <div className="spinner-small"></div>
                                Отправка...
                            </>
                        ) : (
                            <>
                                <Send size={18} />
                                Отправить заявку
                            </>
                        )}
                    </button>
                </form>

            </div>
        </div>
    );
};

export default VacationFormPage;
